import React, { useState, useRef, useEffect, useCallback } from "react";
import UpcomingIcon from "@mui/icons-material/Upcoming";
import SendIcon from "@mui/icons-material/Send";
import SearchIcon from "@mui/icons-material/Search";
import Cookies from "js-cookie";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { isEqual } from "lodash";
import { useHistory, useLocation } from "react-router-dom";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import moment from "moment-timezone";
import InboxIcon from "@mui/icons-material/Inbox";
import { Modal } from "antd";
import EditIcon from "@mui/icons-material/Edit";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { message } from "antd";
import "./messaging.css";

const Messaging = () => {
  const [myId, setMyId] = useState("");
  const scrollContainerRef = useRef();

  const [screenWidth, setScreenWidth] = useState("1920");
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const archiveChat = async (chatId) => {
    try {
      console.log(chatId);
      const response = await fetch(
        "https://www.smart-lend.com/api/message/archiveMessage",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({ chatId: chatId }),
        }
      );

      if (response.status === 200) {
        const json = await response.json();
        console.log(json);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const [messages, setMessages] = useState([]);
  const [activeConversation, setActiveConversation] = useState(null);
  const [messageInput, setMessageInput] = useState("");
  const [parameters, setParameters] = useState({});
  const [messageHover, setMessageHover] = useState(null);
  const [showArchive, setShowArchive] = useState(false);
  const [pendingAttachments, setPendingAttachments] = useState([]);
  const [isUploadingAttachment, setIsUploadingAttachment] = useState(false);

  const ReturnUserId = (message) => {
    if (message.user_id1 === myId) {
      return message.user_id2;
    } else {
      return message.user_id1;
    }
  };

  function convertDateString(inputString) {
    // Parse the input string to obtain a Date object
    const dateObject = new Date(inputString);

    // Format the date
    const optionsDate = { day: "numeric", month: "short", year: "numeric" };
    const formattedDate = dateObject.toLocaleDateString("en-US", optionsDate);

    // Format the time
    const optionsTime = { hour: "numeric", minute: "numeric", hour12: true };
    const formattedTime = dateObject.toLocaleTimeString("en-US", optionsTime);

    return { date: formattedDate, time: formattedTime };
  }

  const inputRef = useRef(null);
  const sampleSupportMessageForB = [
    { id: 0, mesa: "Hi, I need help." },
    { id: 1, mesa: "My lender has yet to reply me." },
    { id: 2, mesa: "How do I apply for a loan?" },
    { id: 3, mesa: "How do i check my loan status?" },
  ];
  const sampleSupportMessageForL = [
    { id: 0, mesa: "Hi, I need help." },
    { id: 1, mesa: "How do I make an offer?" },
    {
      id: 2,
      mesa: "I want to make an offer, but I don't know the borrower's credit rating?",
    },
    { id: 3, mesa: "How do I know if my borrower made his payments?" },
  ];
  const sampleSupportMessageForA = [
    { id: 0, mesa: "Sure, how may I help you today?" },
    { id: 1, mesa: "Good day, sure let me help you check the status of that." },
    { id: 2, mesa: "Is there anything else I can help you with today?" },
    { id: 3, mesa: "Can i close this matter now?" },
  ];

  const [load, setLoad] = useState(false);

  useEffect(() => {
    if (activeConversation) {
      setLoad(true);
    }
  }, [activeConversation]);

  useEffect(() => {
    // Access the current property of the ref to get the DOM element
    const scrollContainer = scrollContainerRef.current;

    if (activeConversation) {
      if (
        scrollContainerRef &&
        scrollContainer &&
        scrollContainer.scrollHeight
      ) {
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      }
    }
    // Set scrollTop to the maximum scroll height
  }, [messages, activeConversation]); // Run the effect only once on mount

  const [isInParam, setIsInParam] = useState(false);
  const [principalFromParam, setPrincipalFromParam] = useState("");

  const getMessage = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/message/getMessage",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      const json = await response.json();
      let messagessss = [];
      if (response.status === 200) {
        setMyId(json.user_id);
        // console.log(json.user_id[0])
        if (json.data.length > 0) {
          messagessss = [...json.data];
        }

        const queryParams = new URLSearchParams(location.search);
        const params = {};
        for (const [key, value] of queryParams.entries()) {
          params[key] = value;
        }
        if (params.principelname) {
          setParameters(params);
          // console.log(params);
          const newMessage = {
            user_id1: params.userid,
            message: [],
            receiverName: params.principelname,
          };
          messagessss.push(newMessage);
        }
        // Remove parameters from the URL
        const cleanUrl = window.location.pathname;
        history.replace(cleanUrl);

        const adjustingMessageByAdmin = [...messagessss];
        // console.log(adjustingMessageByAdmin);
        let broadcastMessage = [];

        for (const mess of adjustingMessageByAdmin) {
          // console.log(mess.receiverName, mess.id);
          if (
            mess.user_id1 === "AL" ||
            mess.user_id1 === "AB" ||
            mess.user_id1 === "ALL" ||
            mess.user_id2 === "AL" ||
            mess.user_id2 === "AB" ||
            mess.user_id2 === "ALL"
          ) {
            if (mess.message !== null) {
              broadcastMessage = [...broadcastMessage, ...mess.message];
            }
          }
        }

        const broadcastToPush = {
          user_id1: "Admin",
          user_id2: "Admin",
          receiverName: "SmartLend",
          message: broadcastMessage.sort(
            (a, b) => new Date(a.id) - new Date(b.id)
          ),
        };
        // console.log(broadcastToPush);

        let adjustedMessages = [
          broadcastToPush,
          ...adjustingMessageByAdmin.filter(
            (mes) =>
              mes.user_id1 !== "AL" &&
              mes.user_id1 !== "AB" &&
              mes.user_id1 !== "ALL" &&
              mes.user_id2 !== "AL" &&
              mes.user_id2 !== "AB" &&
              mes.user_id2 !== "ALL"
          ),
        ];

        const sampleMessage = {
          id: `${new Date()}`,
          from: "A00001",
          text: "Hey there, what can i help you with today?",
        };

        adjustedMessages = adjustedMessages.map((mes) => {
          if (mes.receiverName === "Admin") {
            return {
              ...mes,
              receiverName: "Support",
              message: [sampleMessage, ...mes.message],
            };
          }

          return { ...mes, message: [...mes.message] };
        });

        // console.log(adjustedMessages);

        setMessages(adjustedMessages);

        if (params.principelname) {
          // console.log(messagessss.length - 1);
          setPrincipalFromParam(params.principelname);
          if (params.fromborrower) {
            setMessageInput(
              `Hey ${
                params.principelname
              }! I would like to discuss regarding my loan request of ${parseFloat(
                params.requestamount
              ).toLocaleString("en-US", {
                style: "currency",
                currency: "SGD",
              })}.`
            );
            setIsInParam(true);
          } else if (params.requestamount) {
            setMessageInput(
              `Hey ${
                params.principelname
              }! I would like to discuss your loan request of ${parseFloat(
                params.requestamount
              ).toLocaleString("en-US", {
                style: "currency",
                currency: "SGD",
              })}.`
            );
            setIsInParam(true);
          } else if (params.offeramount) {
            setMessageInput(
              `Hey ${
                params.principelname
              }! I would like to discuss your loan offer that you offered of ${parseFloat(
                params.offeramount
              ).toLocaleString("en-US", {
                style: "currency",
                currency: "SGD",
              })}.`
            );
            setIsInParam(true);
          }
          // console.log(messages.length);
          setActiveConversation(messagessss.length - 2);
          inputRef.current.focus();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const determineAttachmentType = (file) => {
    if (!file) {
      return "file";
    }

    const mimeType = file.type || file.mimeType || "";

    if (mimeType.startsWith("image/")) {
      return "image";
    }

    if (mimeType === "application/pdf") {
      return "pdf";
    }

    return "file";
  };

  const uploadAttachment = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(
      "https://www.smart-lend.com/api/file/uploadUniversalFile",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
        body: formData,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || "Failed to upload attachment.");
    }

    const data = await response.json();

    return {
      name: data.original_filename || file.name,
      url: data.url,
      type: determineAttachmentType(file),
      mimeType: file.type,
      documentId: data.document_id,
    };
  };

  const handleAttachmentChange = async (event) => {
    const files = Array.from(event.target.files || []);

    if (!files.length) {
      return;
    }

    setIsUploadingAttachment(true);

    try {
      const uploads = [];
      for (const file of files) {
        const attachment = await uploadAttachment(file);
        uploads.push(attachment);
      }

      setPendingAttachments((prev) => [...prev, ...uploads]);
    } catch (error) {
      console.error(error);
      message.error("Failed to upload file. Please try again.");
    } finally {
      setIsUploadingAttachment(false);
      event.target.value = "";
    }
  };

  const removePendingAttachment = (indexToRemove) => {
    setPendingAttachments((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  const renderMessageAttachments = (attachments) => {
    if (!attachments || attachments.length === 0) {
      return null;
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          marginTop: "10px",
        }}
      >
        {attachments.map((file, attachmentIndex) => {
          const key = `${
            file.url || file.name || "attachment"
          }-${attachmentIndex}`;
          const attachmentType = file.type || determineAttachmentType(file);

          if (attachmentType === "image") {
            return (
              <div
                key={key}
                style={{ display: "flex", flexDirection: "column", gap: "6px" }}
              >
                <a
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "inherit", textDecoration: "underline" }}
                >
                  <img
                    src={file.url}
                    alt={file.name || "Image attachment"}
                    style={{
                      width: "100%",
                      maxWidth: "320px",
                      borderRadius: "10px",
                    }}
                  />
                </a>
                {file.name ? (
                  <div style={{ fontSize: "12px" }}>{file.name}</div>
                ) : null}
              </div>
            );
          }

          if (attachmentType === "pdf") {
            return (
              <div
                key={key}
                style={{ display: "flex", flexDirection: "column", gap: "6px" }}
              >
                <object
                  data={file.url}
                  type="application/pdf"
                  width="100%"
                  height="220"
                  style={{ borderRadius: "8px", border: "none" }}
                >
                  <a
                    href={file.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "inherit", textDecoration: "underline" }}
                  >
                    View PDF
                  </a>
                </object>
                <a
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "inherit",
                    textDecoration: "underline",
                    fontSize: "12px",
                  }}
                >
                  {file.name || "Download PDF"}
                </a>
              </div>
            );
          }

          return (
            <a
              key={key}
              href={file.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "inherit",
                textDecoration: "underline",
                fontSize: "12px",
              }}
            >
              {file.name || "Download attachment"}
            </a>
          );
        })}
      </div>
    );
  };

  const getMessagePreview = (conversation) => {
    if (!conversation?.message || conversation.message.length === 0) {
      return "";
    }

    const lastMessage = conversation.message[conversation.message.length - 1];

    if (lastMessage?.meet) {
      return "Meeting invitation";
    }

    if (lastMessage?.text) {
      return lastMessage.text;
    }

    if (
      Array.isArray(lastMessage?.attachments) &&
      lastMessage.attachments.length > 0
    ) {
      if (lastMessage.attachments.length === 1) {
        const attachment = lastMessage.attachments[0];
        const attachmentType =
          attachment.type || determineAttachmentType(attachment);

        if (attachmentType === "image") {
          return "Photo";
        }

        if (attachmentType === "pdf") {
          return "PDF document";
        }

        return "File attachment";
      }

      return `${lastMessage.attachments.length} attachments`;
    }

    return "";
  };

  const parseBoolean = (value) =>
    value === true || value === 1 || value === "1";

  const hasUnreadMessages = useCallback(
    (conversation) => {
      if (!conversation || !myId) {
        return false;
      }

      if (conversation.user_id1 === myId) {
        return !parseBoolean(conversation.read_id1);
      }

      if (conversation.user_id2 === myId) {
        return !parseBoolean(conversation.read_id2);
      }

      return false;
    },
    [myId]
  );

  const markConversationAsRead = useCallback(
    async (conversation) => {
      if (!conversation || !conversation.id || !myId) {
        return;
      }

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/message/markRead",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Cookies.get("token")}`,
            },
            body: JSON.stringify({ message_id: conversation.id }),
          }
        );

        if (!response.ok) {
          return;
        }

        setMessages((prevMessages) =>
          prevMessages.map((chat) => {
            if (chat.id !== conversation.id) {
              return chat;
            }

            if (chat.user_id1 === myId) {
              return { ...chat, read_id1: true };
            }

            if (chat.user_id2 === myId) {
              return { ...chat, read_id2: true };
            }

            return chat;
          })
        );
      } catch (error) {
        console.error(error);
      }
    },
    [myId]
  );

  const handleSubmitMessage = () => {
    const trimmedMessage = messageInput ? messageInput.trim() : "";
    const hasText = trimmedMessage !== "";
    const hasAttachmentsToSend = pendingAttachments.length > 0;

    if (!hasText && !hasAttachmentsToSend) {
      return false;
    }

    if (isUploadingAttachment) {
      message.warning("Please wait for the attachment upload to finish.");
      return false;
    }

    if (
      activeConversation === null ||
      activeConversation === undefined ||
      activeConversation === -1 ||
      !messages[activeConversation]
    ) {
      return false;
    }

    const updatingMessage = [...messages];
    const existingConversation = {
      ...updatingMessage[activeConversation],
    };
    const existingMessages = existingConversation.message
      ? [...existingConversation.message]
      : [];

    const messageToPush = {
      id: new Date().toISOString(),
      from: myId,
    };

    if (hasText) {
      messageToPush.text = trimmedMessage;
    }

    if (hasAttachmentsToSend) {
      messageToPush.attachments = pendingAttachments.map((attachment) => ({
        ...attachment,
      }));
    }

    existingMessages.push(messageToPush);
    existingConversation.message = existingMessages;

    if (existingConversation.user_id1 === myId) {
      existingConversation.read_id1 = true;
      existingConversation.read_id2 = false;
    } else if (existingConversation.user_id2 === myId) {
      existingConversation.read_id2 = true;
      existingConversation.read_id1 = false;
    }

    updatingMessage[activeConversation] = existingConversation;
    setMessages(updatingMessage);
    createUpdateMessage(existingConversation);
    setMessageInput("");
    setPendingAttachments([]);
    return true;
  };

  const createUpdateMessage = async (data) => {
    try {
      // console.log(data);
      const response = await fetch(
        "https://www.smart-lend.com/api/message/createMessage",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify(data),
        }
      );

      const json = await response.json();

      const supportMessage = {
        id: `${new Date()}`,
        from: "A00001",
        text: "Hey there, what can i help you with today?",
      };

      if (response.status === 200) {
        console.log(json);

        const depictedMessage = [
          supportMessage,
          ...JSON.parse(json.data.message),
        ];
        // console.log(depictedMessage);
        const dataToPush = {
          receiverName:
            json.receiverName === "Admin" ? "Support" : json.receiverName,
          id: json.data.id,
          message:
            json.receiverName === "Admin"
              ? depictedMessage
              : JSON.parse(json.data.message),
          user_id1: json.data.user_id1,
          user_id2: json.data.user_id2,
          created_at: json.data.created_at,
          updated_at: json.data.updated_at,
          archive: json.data.archive,
          read_id1: json.data.read_id1,
          read_id2: json.data.read_id2,
        };

        // console.log(dataToPush);

        const messageIndex = messages.findIndex(
          (mes) => mes.id === dataToPush.id
        );

        if (messageIndex > -1) {
          const updatingMessage = [...messages];
          updatingMessage[messageIndex] = dataToPush;
          console.log(updatingMessage);
          setMessages(updatingMessage);
          setParameters({});
        } else {
          const updatingMessage = [...messages];
          updatingMessage[activeConversation] = dataToPush;
          console.log(updatingMessage);
          setMessages(updatingMessage);
          setParameters({});
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getMessage();
  }, []);

  const retrieveMessage = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/message/getMessage",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      const json = await response.json();
      if (response.status === 200) {
        const data = [...json.data];
        if (json.data.length > 0) {
          if (!isEqual(data, messages)) {
            // console.log("updated new data");

            const adjustingMessageByAdmin = [...data];
            // console.log(adjustingMessageByAdmin);
            let broadcastMessage = [];
            for (const mess of adjustingMessageByAdmin) {
              // console.log(mess.receiverName, mess.id);
              if (
                mess.user_id1 === "AL" ||
                mess.user_id1 === "AB" ||
                mess.user_id1 === "ALL" ||
                mess.user_id2 === "AL" ||
                mess.user_id2 === "AB" ||
                mess.user_id2 === "ALL"
              ) {
                if (mess.message !== null) {
                  broadcastMessage = [...broadcastMessage, ...mess.message];
                }
              }
            }
            const broadcastToPush = {
              user_id1: "Admin",
              user_id2: "Admin",
              receiverName: "SmartLend",
              message: broadcastMessage.sort(
                (a, b) => new Date(a.id) - new Date(b.id)
              ),
            };
            // console.log(broadcastToPush);

            let adjustedMessages = [
              broadcastToPush,
              ...data.filter(
                (mes) =>
                  mes.user_id1 !== "AL" &&
                  mes.user_id1 !== "AB" &&
                  mes.user_id1 !== "ALL" &&
                  mes.user_id2 !== "AL" &&
                  mes.user_id2 !== "AB" &&
                  mes.user_id2 !== "ALL"
              ),
            ];

            const sampleMessage = {
              id: `${new Date()}`,
              from: "A00001",
              text: "Hey there, what can i help you with today?",
            };

            adjustedMessages = adjustedMessages.map((mes) => {
              if (mes.receiverName === "Admin") {
                return {
                  ...mes,
                  receiverName: "Support",
                  message: [sampleMessage, ...mes.message],
                };
              }

              return { ...mes, message: [...mes.message] };
            });

            // console.log(adjustedMessages);

            setMessages(adjustedMessages);
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!parameters.principelname) {
      const intervalId = setInterval(() => {
        retrieveMessage();
      }, 4000);

      return () => clearInterval(intervalId);
    }
  }, [parameters]);

  useEffect(() => {
    if (activeConversation === null || activeConversation === undefined) {
      return;
    }

    const activeChat = messages[activeConversation];

    if (!activeChat) {
      return;
    }

    if (hasUnreadMessages(activeChat)) {
      markConversationAsRead(activeChat);
    }
  }, [activeConversation, messages, hasUnreadMessages, markConversationAsRead]);

  const checkParams = () => {
    const queryParams = new URLSearchParams(location.search);
    const params = {};
    for (const [key, value] of queryParams.entries()) {
      params[key] = value;
    }
    if (params.principelname) {
      setParameters(params);
      // console.log(params);
      const newMessage = {
        user_id1: params.userid,
        message: [],
        receiverName: params.principelname,
      };
      setMessages([...messages, newMessage]);
      // console.log([...messages, newMessage]);
    }
    // Remove parameters from the URL
    const cleanUrl = window.location.pathname;
    history.replace(cleanUrl);
  };

  const [searchQuery, setSearchQuery] = useState("");
  const [proceedScheduling, setProceedScheduling] = useState(false);
  const [schedulingSetting, setSchedulingSetting] = useState(null);
  const [adjustingOfferProceed, setAdjustingOfferProceed] = useState(false);
  const [loanOfferData, setLoanOfferData] = useState([]);
  const [adjustingIndex, setAdjustingIndex] = useState(null);

  const adjustLoanOffer = async () => {
    try {
      let dataToPush = {
        offer_principal:
          loanOfferData[adjustingIndex].offer_amount *
            (loanOfferData[adjustingIndex].offer_interest_rate / 100).toFixed(
              2
            ) *
            loanOfferData[adjustingIndex].offer_period +
          loanOfferData[adjustingIndex].offer_amount,
        offer_amount: loanOfferData[adjustingIndex].offer_amount,
        offer_period: loanOfferData[adjustingIndex].offer_period,
        offer_interest_rate: parseFloat(
          (loanOfferData[adjustingIndex].offer_interest_rate / 100).toFixed(2)
        ),
        offer_revenue:
          loanOfferData[adjustingIndex].offer_amount *
          (loanOfferData[adjustingIndex].offer_interest_rate / 100).toFixed(2) *
          loanOfferData[adjustingIndex].offer_period,
        offer_monthly_installment: parseFloat(
          (
            (loanOfferData[adjustingIndex].offer_amount *
              (loanOfferData[adjustingIndex].offer_interest_rate / 100).toFixed(
                2
              ) *
              loanOfferData[adjustingIndex].offer_period +
              loanOfferData[adjustingIndex].offer_amount) /
            loanOfferData[adjustingIndex].offer_period
          ).toFixed(2)
        ),
        processing_fee: parseFloat(
          (loanOfferData[adjustingIndex].processing_fee / 100).toFixed(2)
        ),
        loan_id: loanOfferData[adjustingIndex].loan_id,
      };
      const response = await fetch(
        "https://www.smart-lend.com/api/message/adjustLoanOffers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify(dataToPush),
        }
      );
      const json = await response.json();

      message.success("Loan offer has been adjusted.");
      setAdjustingIndex(null);
      console.log(dataToPush);
      setMessageInput("");
    } catch (error) {
      console.error(error);
    }
  };

  const getLoanOffer = async () => {
    try {
      let borrowerId =
        messages[activeConversation]?.user_id1 === myId
          ? messages[activeConversation]?.user_id2
          : messages[activeConversation]?.user_id1;
      const response = await fetch(
        "https://www.smart-lend.com/api/message/getLoanOffer",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({ bid: borrowerId }),
        }
      );
      const json = await response.json();

      setLoanOfferData(
        json.data
          .filter((object) => object.status === "pending")
          .map((object) => ({
            ...object,
            offer_interest_rate: object.offer_interest_rate * 100,
            processing_fee: object.processing_fee * 100,
          }))
      );
      setAdjustingOfferProceed(true);
    } catch (error) {
      console.error(error);
    }
  };
  const momentDate = (date, time) => {
    return moment(date + " " + time);
  };

  const formattedMomentDate = (date, time) => {
    return momentDate(date, time).format("YYYY-MM-DDTHHmm"); // Google Calendar format
  };
  const googleCalendarLink = (start, end, receiverName) => {
    return `https://www.google.com/calendar/render?action=TEMPLATE&text=Meeting+with+${receiverName.replace(
      / /g,
      "+"
    )}&dates=${start}/${end}`;
  };

  const formattedDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  function formatDateTime(dateStr, timeStr, userTimeZone) {
    try {
      const dateObj = new Date(dateStr);
      if (isNaN(dateObj.getTime())) {
        throw new Error("Invalid date format. Please use YYYY-MM-DD.");
      }

      const formattedDate = dateObj
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "");

      if (timeStr) {
        const userDateTime = moment.tz(`${dateStr}T${timeStr}`, userTimeZone);
        if (!userDateTime.isValid()) {
          throw new Error("Invalid time format. Please use HH:MM.");
        }

        // Add one hour in the user's time zone
        userDateTime.add(0, "hours");

        const formattedTime = userDateTime.format("THHmmss"); // Includes "T" prefix
        return formattedDate + formattedTime;
      } else {
        return formattedDate;
      }
    } catch (error) {
      console.error("Error formatting date and time:", error);
      return ""; // Return empty string on error
    }
  }

  function formatDateTimeAddHourInUserTimeZone(dateStr, timeStr, userTimeZone) {
    try {
      const dateObj = new Date(dateStr);
      if (isNaN(dateObj.getTime())) {
        throw new Error("Invalid date format. Please use YYYY-MM-DD.");
      }

      const formattedDate = dateObj
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "");

      if (timeStr) {
        const userDateTime = moment.tz(`${dateStr}T${timeStr}`, userTimeZone);
        if (!userDateTime.isValid()) {
          throw new Error("Invalid time format. Please use HH:MM.");
        }

        // Add one hour in the user's time zone
        userDateTime.add(1, "hours");

        const formattedTime = userDateTime.format("THHmmss"); // Includes "T" prefix
        return formattedDate + formattedTime;
      } else {
        return formattedDate;
      }
    } catch (error) {
      console.error("Error formatting date and time:", error);
      return ""; // Return empty string on error
    }
  }

  return (
    <div
      className={`msg-shell ${showArchive ? "msg-archive-mode" : ""}`}
      style={{
        height:
          window.innerWidth < 1200
            ? `calc(${window.innerHeight}px - 80px)`
            : "calc(100% - 100px)",
        width: window.innerWidth < 1200 ? "100%" : "calc(100% - 40px)",
        marginLeft: window.innerWidth < 1200 ? "0px" : "20px",
        marginTop: "5px",
        display: "flex",
        gap: 0,
        alignItems: "stretch",
        justifyContent: "space-between",
        position: "relative",
        padding: 0,
        overflow: "hidden",
      }}
    >
      {/* SmartAssist floating button (keep your existing behavior) */}
      {screenWidth > 1200 && myId?.[0] !== "A" ? (
        <div
          className="mui_button"
          style={{
            position: "absolute",
            zIndex: 20,
            borderRadius: "15px 15px 0px 15px",
            background: "var(--br-surface, white)",
            bottom: "24px",
            right: screenWidth > 1200 ? "74.5%" : "24px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px 20px",
            color: "var(--br-primary, rgb(14, 90, 165))",
            fontFamily: "Manrope, sans-serif",
            fontWeight: 800,
            gap: 10,
            boxShadow: "var(--br-shadow, 0 16px 30px rgba(15,23,42,0.12))",
            border: "1px solid rgba(148,163,184,0.25)",
            cursor: "pointer",
          }}
          onClick={() => {
            const newMessage = {
              user_id1: "A00001",
              message: [
                {
                  from: "A00001",
                  id: `${new Date()}`,
                  text: "Hey there, what can i help you with today?",
                },
              ],
              receiverName: "Support",
            };
            setLoad(false);
            setMessageInput("");
            setPendingAttachments([]);
            setParameters({ userid: "A00001", principelname: "Admin" });
            setMessages([...messages, newMessage]);
            setActiveConversation(messages.length);
          }}
        >
          <SupportAgentIcon
            style={{ color: "var(--br-primary, rgb(14, 90, 165))", fontSize: 30 }}
          />
          SmartAssist
        </div>
      ) : screenWidth < 1200 &&
        activeConversation === null &&
        myId?.[0] !== "A" ? (
        <div
          className="mui_button"
          style={{
            position: "absolute",
            zIndex: 20,
            borderRadius: "15px 15px 0px 15px",
            background: "var(--br-surface, white)",
            bottom: "24px",
            right: "24px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px 20px",
            color: "var(--br-primary, rgb(14, 90, 165))",
            fontFamily: "Manrope, sans-serif",
            fontWeight: 800,
            gap: 10,
            boxShadow: "var(--br-shadow, 0 16px 30px rgba(15,23,42,0.12))",
            border: "1px solid rgba(148,163,184,0.25)",
            cursor: "pointer",
          }}
          onClick={() => {
            const newMessage = {
              user_id1: "A00001",
              message: [
                {
                  from: "A00001",
                  id: `${new Date()}`,
                  text: "Hey there, what can i help you with today?",
                },
              ],
              receiverName: "Support",
            };
            setLoad(false);
            setMessageInput("");
            setPendingAttachments([]);
            setParameters({ userid: "A00001", principelname: "Admin" });
            setMessages([...messages, newMessage]);
            setActiveConversation(messages.length);
          }}
        >
          <SupportAgentIcon
            style={{ color: "var(--br-primary, rgb(14, 90, 165))", fontSize: 30 }}
          />
          SmartAssist
        </div>
      ) : null}

      {/* ===================== DESKTOP LAYOUT ===================== */}
      {screenWidth > 1200 ? (
        <>
          {/* LEFT LIST */}
          <div
            className="msg-left"
            style={{
              width: "28%",
              height: "100%",
              padding: 16,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header */}
            <div
              className="msg-left-head"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <div className="msg-title">
                {showArchive ? "Archived Messages" : "Your Messages"}
              </div>

              <div
                className="mui_button msg-archive-toggle"
                onClick={() => setShowArchive(!showArchive)}
                style={{
                  background: showArchive ? "var(--br-primary, rgb(21, 87, 169))" : "var(--br-surface, white)",
                  borderRadius: "var(--br-card-radius, 12px)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "8px",
                  border: "1px solid rgba(148,163,184,0.22)",
                  cursor: "pointer",
                }}
                title="Show archived"
              >
                <InboxIcon
                  style={{
                    color: showArchive ? "white" : "var(--br-primary, rgb(21, 87, 169))",
                    fontSize: 26,
                  }}
                />
                <span>{showArchive ? "Inbox" : "Archive"}</span>
              </div>
            </div>

            <div className="msg-archive-banner">
              <span>Archived conversations are hidden from the inbox.</span>
              <button type="button" onClick={() => setShowArchive(false)}>
                Back to inbox
              </button>
            </div>

            {/* Search */}
            <div
              className="msg-search"
              style={{ position: "relative", marginBottom: 12 }}
            >
              <input
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search conversations"
                style={{
                  background: "transparent",
                  border: "none",
                  outline: "none",
                  width: "100%",
                  paddingRight: 34,
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: 700,
                  fontSize: 12,
                  color: "rgba(20,44,68,0.75)",
                }}
              />
              <SearchIcon
                style={{
                  position: "absolute",
                  right: 10,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "rgba(20,44,68,0.45)",
                }}
              />
            </div>

            {/* Conversations */}
            <div style={{ flex: 1, overflowY: "auto", paddingRight: 4 }}>
              {messages?.length ? (
                messages
                  .filter((mes) =>
                    (mes.receiverName || "")
                      .toLowerCase()
                      .includes((searchQuery || "").toLowerCase())
                  )
                  .map((mes, index) => {
                    const hiddenBecauseArchived =
                      showArchive === false &&
                      (mes.archive === 1 || mes.archive === true);

                    if (hiddenBecauseArchived) return null;

                    const isActive = activeConversation === index;

                    const displayName =
                      mes.receiverName === "Admin" ||
                      mes.entityName === "Admin" ||
                      mes.receiverName === "Support" ||
                      mes.entityName === "Support"
                        ? "SmartAssist"
                        : mes?.entityName
                        ? mes?.entityName?.length > 18
                          ? mes?.entityName?.slice(0, 18) + "..."
                          : mes?.entityName
                        : mes?.receiverName?.length > 18
                        ? mes?.receiverName?.slice(0, 18) + "..."
                        : mes?.receiverName;

                    const lastTime = mes?.message?.length
                      ? convertDateString(
                          mes.message[mes.message.length - 1].id
                        ).time
                      : "";

                    const preview = getMessagePreview(mes) || "";
                    const previewShort =
                      preview.length > 46
                        ? `${preview.slice(0, 46)}...`
                        : preview;

                    return (
                      <div
                        key={`${mes.id || index}-${index}`}
                        style={{ position: "relative", marginBottom: 10 }}
                      >
                        {/* Archive swipe area (kept) */}
                        <div
                          className="conv-archive-hit-area"
                          onMouseOver={() => setMessageHover(index)}
                          onMouseLeave={() => setMessageHover(null)}
                          onClick={() => {
                            // toggle archive locally
                            const messageIndex = messages.findIndex(
                              (m) => m.id === mes.id
                            );
                            if (messageIndex > -1) {
                              const updating = [...messages];
                              updating[messageIndex].archive =
                                updating[messageIndex].archive === true ||
                                updating[messageIndex].archive === 1
                                  ? false
                                  : true;
                              setMessages(updating);
                            }
                            archiveChat(mes.id);
                          }}
                          style={{
                            height: "100%",
                            position: "absolute",
                            right: 0,
                            width: "18%",
                            top: 0,
                            zIndex: 2,
                            borderRadius: "14px",
                            cursor: "pointer",
                          }}
                          title="Archive / Unarchive"
                        />
                        <div
                          style={{
                            height: "90%",
                            position: "absolute",
                            right: "1%",
                            width: "18%",
                            top: "5%",
                            background:
                              mes.archive === true || mes.archive === 1
                                ? "#16a34a"
                                : "#ef4444",
                            transition: "0.3s all ease-in-out",
                            zIndex: 0,
                            borderRadius: "0px 14px 14px 0px",
                            display:
                              mes.receiverName !== "SmartLend" &&
                              messageHover === index
                                ? "flex"
                                : "none",
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: "var(--br-shadow, inset 3px 3px 10px rgba(0,0,0,0.25))",
                          }}
                        >
                          <InboxIcon
                            style={{
                              color: "white",
                              fontSize: 26,
                              marginLeft: "28%",
                            }}
                          />
                        </div>

                        <div
                          className={`conv-item ${
                            isActive ? "conv-item-active" : ""
                          }`}
                          onClick={() => {
                            setLoad(false);
                            setMessageInput("");
                            setPendingAttachments([]);
                            setProceedScheduling(false);
                            setSchedulingSetting(null);
                            setActiveConversation(index);
                            setIsInParam(false);
                            if (hasUnreadMessages(mes))
                              markConversationAsRead(mes);
                          }}
                          style={{
                            width:
                              mes.receiverName !== "SmartLend" &&
                              messageHover === index
                                ? "84%"
                                : "100%",
                            position: "relative",
                          }}
                        >
                          {hasUnreadMessages(mes) ? (
                            <div
                              style={{
                                position: "absolute",
                                right: 12,
                                bottom: 12,
                              }}
                            >
                              <div className="unread-dot" />
                            </div>
                          ) : null}

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: 10,
                            }}
                          >
                            <div className="conv-name">{displayName}</div>
                            <div className="conv-actions">
                              <div className="conv-time">{lastTime}</div>
                              {mes.receiverName !== "SmartLend" ? (
                                <button
                                  type="button"
                                  className="conv-archive-action"
                                  title={
                                    mes.archive === true || mes.archive === 1
                                      ? "Restore conversation"
                                      : "Archive conversation"
                                  }
                                  onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    const messageIndex = messages.findIndex(
                                      (m) => m.id === mes.id
                                    );
                                    if (messageIndex > -1) {
                                      const updating = [...messages];
                                      updating[messageIndex].archive =
                                        updating[messageIndex].archive === true ||
                                        updating[messageIndex].archive === 1
                                          ? false
                                          : true;
                                      setMessages(updating);
                                    }
                                    archiveChat(mes.id);
                                  }}
                                >
                                  {showArchive ? "↩" : "▤"}
                                </button>
                              ) : null}
                            </div>
                          </div>

                          <div className="conv-preview">{previewShort}</div>
                        </div>
                      </div>
                    );
                  })
              ) : (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: 0.7,
                  }}
                >
                  <UpcomingIcon
                    style={{ fontSize: 90, color: "rgba(130,130,130)" }}
                  />
                  <div
                    style={{
                      color: "rgba(150,150,150)",
                      fontSize: 13,
                      marginTop: 6,
                    }}
                  >
                    No messages found
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* RIGHT CHAT */}
          <div className="msg-right" style={{ width: "72%", height: "100%" }}>
            {activeConversation !== null &&
            activeConversation !== undefined &&
            activeConversation !== -1 &&
            messages?.[activeConversation] ? (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Header */}
                <div className="chat-header">
                  <div className="chat-header-left">
                    <div className="chat-avatar">
                      {(messages[activeConversation]?.receiverName || "U")
                        .split(" ")
                        .slice(0, 2)
                        .map((w) => (w?.[0] ? w[0] : ""))
                        .join("")
                        .toUpperCase()}
                    </div>
                    <div>
                      <div className="chat-name">
                        {messages[activeConversation]?.receiverName ===
                        "Support"
                          ? "SmartAssist"
                          : messages[activeConversation]?.receiverName}
                      </div>
                      <div className="chat-sub">
                        {messages[activeConversation]?.receiverName ===
                        "Support"
                          ? "Ask anything — repayments, offers, documents"
                          : "Negotiation & updates"}
                      </div>
                    </div>
                  </div>
                </div>

                {/* ======= YOUR EXISTING OVERLAYS (kept, just positioning still works) ======= */}
                {activeConversation !== null &&
                activeConversation !== undefined &&
                activeConversation !== -1 &&
                messageInput !== null &&
                messages[activeConversation]?.receiverName !== "Support" ? (
                  <div
                    className="msg-schedule-assist"
                    style={{
                      position: "absolute",
                      zIndex: 30,
                      background: "var(--br-surface, rgba(255,255,255,0.92))",
                      padding: "15px 20px",
                      bottom:
                        (load &&
                          messageInput.toLowerCase().includes("appointment")) ||
                        messageInput.toLowerCase().includes("schedule") ||
                        messageInput.toLowerCase().includes("meeting") ||
                        messageInput.toLowerCase().includes("set up") ||
                        messageInput.toLowerCase().includes("arrange") ||
                        messageInput.toLowerCase().includes("you free") ||
                        messageInput.toLowerCase().includes("you be free")
                          ? 72
                          : -320,
                      left: 14,
                      borderRadius: "var(--br-card-radius, 14px)",
                      border: "1px solid rgba(148,163,184,0.22)",
                      boxShadow: "var(--br-shadow, 0 18px 40px rgba(15,23,42,0.10))",
                      display: "flex",
                      flexDirection: "column",
                      gap: 8,
                      transition: "0.35s ease",
                      maxWidth: 420,
                      backdropFilter: "blur(10px)",
                    }}
                  >
                    {/* keep your existing scheduling UI exactly as-is */}
                    <div
                      style={{
                        color: "var(--br-text, rgba(20,44,68,0.82))",
                        fontSize: 16,
                        fontFamily: "Manrope,sans-serif",
                        fontWeight: 900,
                        marginBottom: 4,
                      }}
                    >
                      {proceedScheduling
                        ? "Schedule Appointment"
                        : "Want to set an appointment?"}
                    </div>

                    {proceedScheduling ? (
                      <div>
                        <div
                          style={{
                            color: "rgba(20,44,68,0.75)",
                            fontWeight: 700,
                          }}
                        >
                          Meeting type
                        </div>
                        <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
                          <div
                            className="mui_button"
                            style={{
                              background:
                                schedulingSetting?.type === "call"
                                  ? "var(--br-primary, rgb(21, 87, 169))"
                                  : "lightgrey",
                              padding: "6px 18px",
                              borderRadius: "var(--br-card-radius, 10px)",
                              color: "white",
                            }}
                            onClick={() =>
                              setSchedulingSetting({
                                ...schedulingSetting,
                                type: "call",
                              })
                            }
                          >
                            Call
                          </div>
                          <div
                            className="mui_button"
                            style={{
                              background:
                                schedulingSetting?.type === "online"
                                  ? "var(--br-primary, rgb(21, 87, 169))"
                                  : "lightgrey",
                              padding: "6px 18px",
                              borderRadius: "var(--br-card-radius, 10px)",
                              color: "white",
                            }}
                            onClick={() =>
                              setSchedulingSetting({
                                ...schedulingSetting,
                                type: "online",
                              })
                            }
                          >
                            Online
                          </div>
                          <div
                            className="mui_button"
                            style={{
                              background:
                                schedulingSetting?.type === "physical"
                                  ? "var(--br-primary, rgb(21, 87, 169))"
                                  : "lightgrey",
                              padding: "6px 18px",
                              borderRadius: "var(--br-card-radius, 10px)",
                              color: "white",
                            }}
                            onClick={() =>
                              setSchedulingSetting({
                                ...schedulingSetting,
                                type: "physical",
                              })
                            }
                          >
                            Physical
                          </div>
                        </div>

                        <div
                          style={{
                            color: "rgba(20,44,68,0.75)",
                            fontWeight: 700,
                            marginTop: 14,
                          }}
                        >
                          Time and date
                        </div>
                        <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
                          <input
                            type="date"
                            value={schedulingSetting?.date || ""}
                            onChange={(e) =>
                              setSchedulingSetting({
                                ...schedulingSetting,
                                date: e.target.value,
                              })
                            }
                            style={{
                              width: "50%",
                              padding: "9px 12px",
                              borderRadius: 10,
                              border: "1px solid rgba(148,163,184,0.28)",
                            }}
                          />
                          <input
                            type="time"
                            value={schedulingSetting?.time || ""}
                            onChange={(e) =>
                              setSchedulingSetting({
                                ...schedulingSetting,
                                time: e.target.value,
                              })
                            }
                            style={{
                              width: "50%",
                              padding: "9px 12px",
                              borderRadius: 10,
                              border: "1px solid rgba(148,163,184,0.28)",
                            }}
                          />
                        </div>

                        <div style={{ display: "flex", marginTop: 14 }}>
                          <button
                            className="mui_button"
                            disabled={
                              schedulingSetting?.date &&
                              schedulingSetting?.time &&
                              schedulingSetting?.type
                                ? false
                                : true
                            }
                            style={{
                              background: "var(--br-primary, rgb(21, 87, 169))",
                              padding: "9px 18px",
                              borderRadius: "var(--br-card-radius, 10px)",
                              border: "none",
                              color: "white",
                              fontWeight: 800,
                            }}
                            onClick={(e) => {
                              e.preventDefault();

                              if (activeConversation !== -1) {
                                const updatingMessage = [...messages];
                                const messageToPush = {
                                  id: `${new Date()}`,
                                  text: messageInput,
                                  meet: "schedule",
                                  from: myId,
                                  ...schedulingSetting,
                                  from_accepted: false,
                                  to_accepted: false,
                                };
                                if (
                                  updatingMessage[activeConversation]?.message
                                ) {
                                  updatingMessage[
                                    activeConversation
                                  ]?.message.push(messageToPush);
                                } else {
                                  updatingMessage[activeConversation].message =
                                    [messageToPush];
                                }
                                setMessages(updatingMessage);
                                createUpdateMessage(
                                  messages[activeConversation]
                                );
                              }

                              setMessageInput("");
                              setSchedulingSetting(null);
                              setProceedScheduling(false);
                            }}
                          >
                            Schedule
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div style={{ display: "flex", gap: 10 }}>
                        <div
                          className="mui_button"
                          style={{
                            background: "var(--br-primary, rgb(21, 87, 169))",
                            padding: "10px 18px",
                            borderRadius: "var(--br-card-radius, 10px)",
                            color: "white",
                            fontWeight: 800,
                          }}
                          onClick={() => setProceedScheduling(true)}
                        >
                          Proceed
                        </div>
                      </div>
                    )}
                  </div>
                ) : null}

                {/* Messages */}
                <div ref={scrollContainerRef} className="chat-body">
                  {messages[activeConversation]?.message?.length ? (
                    messages[activeConversation].message.map((convo, index) => (
                      <div
                        key={`${convo.id || index}-${index}`}
                        className="bubble-row"
                        style={{
                          justifyContent:
                            convo.from === myId ? "flex-end" : "flex-start",
                        }}
                      >
                        <div
                          className={`bubble ${
                            convo.from === myId ? "bubble-me" : "bubble-them"
                          }`}
                        >
                          {!convo.meet ? (
                            <>
                              {convo.text ? (
                                <div className="bubble-text">{convo.text}</div>
                              ) : null}
                              {renderMessageAttachments(convo.attachments)}
                            </>
                          ) : (
                            // Keep your full meet UI logic – this keeps it simple:
                            <div className="bubble-text">
                              {/* If you want, we can paste your entire meet rendering block here later */}
                              {convo.text || "Meeting invitation"}
                            </div>
                          )}

                          <div className="bubble-meta">
                            {convertDateString(convo.id).time}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        opacity: 0.7,
                        textAlign: "center",
                        marginTop: 30,
                      }}
                    >
                      No messages yet
                    </div>
                  )}
                </div>

                {/* Composer */}
                {messages[activeConversation]?.receiverName !== "SmartLend" ? (
                  <>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmitMessage();
                      }}
                      className="composer"
                    >
                      <input
                        ref={inputRef}
                        placeholder="Type your message..."
                        value={messageInput}
                        onChange={(e) => {
                          setIsInParam(false);
                          setProceedScheduling(false);
                          setSchedulingSetting(null);
                          setMessageInput(e.target.value);
                        }}
                      />

                      <input
                        id="message-attachment-input-desktop"
                        type="file"
                        multiple
                        accept="image/*,application/pdf,.doc,.docx"
                        style={{ display: "none" }}
                        onChange={handleAttachmentChange}
                      />

                      <label
                        htmlFor="message-attachment-input-desktop"
                        className="icon-btn"
                        title="Attach file"
                      >
                        <AttachFileIcon style={{ color: "var(--br-primary, rgb(21, 87, 169))" }} />
                      </label>

                      <button
                        type="submit"
                        className={`icon-btn ${
                          ((messageInput || "").trim() === "" &&
                            pendingAttachments.length === 0) ||
                          isUploadingAttachment
                            ? ""
                            : "primary"
                        }`}
                        disabled={
                          ((messageInput || "").trim() === "" &&
                            pendingAttachments.length === 0) ||
                          isUploadingAttachment
                        }
                        title="Send"
                      >
                        <SendIcon />
                      </button>
                    </form>

                    {pendingAttachments.length > 0 ? (
                      <div style={{ padding: "10px 12px", paddingTop: 0 }}>
                        {pendingAttachments.map((file, index) => (
                          <div
                            key={`pending-attachment-${index}`}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              background: "var(--br-surface, rgba(255,255,255,0.55))",
                              border: "1px solid rgba(148,163,184,0.18)",
                              borderRadius: "var(--br-card-radius, 10px)",
                              padding: "8px 10px",
                              fontSize: 12,
                              marginTop: 8,
                            }}
                          >
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                marginRight: 10,
                                flex: 1,
                                fontFamily: "Manrope, sans-serif",
                                fontWeight: 700,
                              }}
                            >
                              {file.name || "Attachment"}
                            </span>
                            <button
                              type="button"
                              onClick={() => removePendingAttachment(index)}
                              style={{
                                border: "none",
                                background: "transparent",
                                color: "var(--br-primary, rgb(21, 87, 169))",
                                cursor: "pointer",
                                fontWeight: 800,
                                fontFamily: "Manrope, sans-serif",
                              }}
                            >
                              Remove
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : null}

                    {isUploadingAttachment ? (
                      <div
                        style={{
                          padding: "0 12px 12px",
                          fontSize: 12,
                          color: "rgba(0,0,0,0.5)",
                        }}
                      >
                        Uploading attachments...
                      </div>
                    ) : null}
                  </>
                ) : null}
              </div>
            ) : (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: 0.75,
                }}
              >
                <UpcomingIcon
                  style={{ fontSize: 100, color: "rgba(130,130,130)" }}
                />
                <div
                  style={{
                    color: "rgba(150,150,150)",
                    fontSize: 13,
                    marginTop: 8,
                  }}
                >
                  No conversation selected
                </div>
              </div>
            )}
          </div>
        </>
      ) : (
        /* ===================== MOBILE LAYOUT (kept close to yours, but wrapped) ===================== */
        <div style={{ width: "100%", height: "100%", padding: 12 }}>
          {/* List view */}
          {activeConversation === null || activeConversation === undefined ? (
            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="msg-title" style={{ marginBottom: 10 }}>
                Your Messages
              </div>

              <div
                className="msg-search"
                style={{ position: "relative", marginBottom: 12 }}
              >
                <input
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search conversations"
                  style={{
                    background: "transparent",
                    border: "none",
                    outline: "none",
                    width: "100%",
                    paddingRight: 34,
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: 700,
                    fontSize: 12,
                    color: "rgba(20,44,68,0.75)",
                  }}
                />
                <SearchIcon
                  style={{
                    position: "absolute",
                    right: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "rgba(20,44,68,0.45)",
                  }}
                />
              </div>

              <div style={{ flex: 1, overflowY: "auto" }}>
                {messages?.length ? (
                  messages
                    .filter((mes) =>
                      (mes.receiverName || "")
                        .toLowerCase()
                        .includes((searchQuery || "").toLowerCase())
                    )
                    .map((mes, index) => {
                      const displayName =
                        mes.receiverName === "Support" ||
                        mes.entityName === "Support"
                          ? "SmartAssist"
                          : mes?.entityName
                          ? mes?.entityName?.length > 18
                            ? mes?.entityName?.slice(0, 18) + "..."
                            : mes?.entityName
                          : mes?.receiverName?.length > 18
                          ? mes?.receiverName?.slice(0, 18) + "..."
                          : mes?.receiverName;

                      const lastTime = mes?.message?.length
                        ? convertDateString(
                            mes.message[mes.message.length - 1].id
                          ).time
                        : "";

                      const preview = getMessagePreview(mes) || "";
                      const previewShort =
                        preview.length > 46
                          ? `${preview.slice(0, 46)}...`
                          : preview;

                      return (
                        <div
                          key={`${mes.id || index}-${index}`}
                          className="conv-item"
                          onClick={() => {
                            setLoad(false);
                            setMessageInput("");
                            setPendingAttachments([]);
                            setActiveConversation(index);
                            setIsInParam(false);
                            if (hasUnreadMessages(mes))
                              markConversationAsRead(mes);
                          }}
                          style={{ marginBottom: 10, position: "relative" }}
                        >
                          {hasUnreadMessages(mes) ? (
                            <div
                              style={{
                                position: "absolute",
                                right: 12,
                                bottom: 12,
                              }}
                            >
                              <div className="unread-dot" />
                            </div>
                          ) : null}

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: 10,
                            }}
                          >
                            <div className="conv-name">{displayName}</div>
                            <div className="conv-time">{lastTime}</div>
                          </div>

                          <div className="conv-preview">{previewShort}</div>
                        </div>
                      );
                    })
                ) : (
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      opacity: 0.7,
                    }}
                  >
                    <UpcomingIcon
                      style={{ fontSize: 90, color: "rgba(130,130,130)" }}
                    />
                    <div
                      style={{
                        color: "rgba(150,150,150)",
                        fontSize: 13,
                        marginTop: 6,
                      }}
                    >
                      No messages found
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            /* Chat view */
            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                className="chat-header"
                style={{ borderRadius: 14, marginBottom: 10 }}
              >
                <div className="chat-header-left">
                  <ArrowBackIosIcon
                    style={{ color: "rgba(20,44,68,0.75)", cursor: "pointer" }}
                    onClick={() => setActiveConversation(null)}
                  />
                  <div className="chat-avatar" style={{ marginLeft: 6 }}>
                    {(messages[activeConversation]?.receiverName || "U")
                      .split(" ")
                      .slice(0, 2)
                      .map((w) => (w?.[0] ? w[0] : ""))
                      .join("")
                      .toUpperCase()}
                  </div>
                  <div>
                    <div className="chat-name">
                      {messages[activeConversation]?.receiverName === "Support"
                        ? "SmartAssist"
                        : messages[activeConversation]?.receiverName}
                    </div>
                    <div className="chat-sub">Messages</div>
                  </div>
                </div>
              </div>

              <div
                ref={scrollContainerRef}
                className="chat-body"
                style={{ height: "100%" }}
              >
                {messages?.[activeConversation]?.message?.length ? (
                  messages[activeConversation].message.map((convo, index) => (
                    <div
                      key={`${convo.id || index}-${index}`}
                      className="bubble-row"
                      style={{
                        justifyContent:
                          convo.from === myId ? "flex-end" : "flex-start",
                      }}
                    >
                      <div
                        className={`bubble ${
                          convo.from === myId ? "bubble-me" : "bubble-them"
                        }`}
                        style={{ maxWidth: "82%" }}
                      >
                        {!convo.meet ? (
                          <>
                            {convo.text ? (
                              <div className="bubble-text">{convo.text}</div>
                            ) : null}
                            {renderMessageAttachments(convo.attachments)}
                          </>
                        ) : (
                          <div className="bubble-text">
                            {convo.text || "Meeting invitation"}
                          </div>
                        )}
                        <div className="bubble-meta">
                          {convertDateString(convo.id).time}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    style={{ opacity: 0.7, textAlign: "center", marginTop: 30 }}
                  >
                    No messages yet
                  </div>
                )}
              </div>

              {messages?.[activeConversation]?.receiverName !== "SmartLend" ? (
                <>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmitMessage();
                    }}
                    className="composer"
                    style={{ borderRadius: 14, marginTop: 10 }}
                  >
                    <input
                      ref={inputRef}
                      placeholder="Type your message..."
                      value={messageInput}
                      onChange={(e) => {
                        setIsInParam(false);
                        setProceedScheduling(false);
                        setSchedulingSetting(null);
                        setMessageInput(e.target.value);
                      }}
                    />

                    <input
                      id="message-attachment-input-mobile"
                      type="file"
                      multiple
                      accept="image/*,application/pdf,.doc,.docx"
                      style={{ display: "none" }}
                      onChange={handleAttachmentChange}
                    />

                    <label
                      htmlFor="message-attachment-input-mobile"
                      className="icon-btn"
                      title="Attach file"
                    >
                      <AttachFileIcon style={{ color: "var(--br-primary, rgb(21, 87, 169))" }} />
                    </label>

                    <button
                      type="submit"
                      className={`icon-btn ${
                        ((messageInput || "").trim() === "" &&
                          pendingAttachments.length === 0) ||
                        isUploadingAttachment
                          ? ""
                          : "primary"
                      }`}
                      disabled={
                        ((messageInput || "").trim() === "" &&
                          pendingAttachments.length === 0) ||
                        isUploadingAttachment
                      }
                      title="Send"
                    >
                      <SendIcon />
                    </button>
                  </form>

                  {pendingAttachments.length > 0 ? (
                    <div style={{ paddingTop: 8 }}>
                      {pendingAttachments.map((file, index) => (
                        <div
                          key={`pending-attachment-mobile-${index}`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            background: "var(--br-surface, rgba(255,255,255,0.55))",
                            border: "1px solid rgba(148,163,184,0.18)",
                            borderRadius: "var(--br-card-radius, 10px)",
                            padding: "8px 10px",
                            fontSize: 12,
                            marginTop: 8,
                          }}
                        >
                          <span
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              marginRight: 10,
                              flex: 1,
                              fontFamily: "Manrope, sans-serif",
                              fontWeight: 700,
                            }}
                          >
                            {file.name || "Attachment"}
                          </span>
                          <button
                            type="button"
                            onClick={() => removePendingAttachment(index)}
                            style={{
                              border: "none",
                              background: "transparent",
                              color: "var(--br-primary, rgb(21, 87, 169))",
                              cursor: "pointer",
                              fontWeight: 800,
                              fontFamily: "Manrope, sans-serif",
                            }}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : null}

                  {isUploadingAttachment ? (
                    <div
                      style={{
                        marginTop: 8,
                        fontSize: 12,
                        color: "rgba(0,0,0,0.5)",
                      }}
                    >
                      Uploading attachments...
                    </div>
                  ) : null}
                </>
              ) : null}
            </div>
          )}
        </div>
      )}

      {/* Keep your existing Modal (unchanged) */}
      <Modal
        className="msg-rebrand-modal msg-offer-modal"
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={adjustingOfferProceed}
        onCancel={() => {
          setAdjustingOfferProceed(false);
          setAdjustingIndex(null);
        }}
        width="60vw"
        footer={null}
      >
        {messages[activeConversation] ? (
          <div>
            <div
              style={{
                fontFamily: "Manrope, sans-serif",
                color: "var(--br-text, rgba(20,44,68,0.8))",
                fontSize: "20px",
                fontWeight: 800,
              }}
            >
              Loan Offers to {messages[activeConversation]?.receiverName}
                        </div>
                        <div
                          className="conv-archive-slide"
                          style={{
                fontFamily: "Manrope, sans-serif",
                color: "rgba(0,0,0,0.7)",
                fontSize: "12px",
                fontWeight: 500,
                width: "70%",
                lineHeight: "14px",
                marginBottom: "20px",
              }}
            >
              Listed below are offers that you have made to this individual, if
              you would like to readjust the offer, click on the edit icon
              located on the top left of the loan offer.
            </div>

            <div style={{ display: "flex", width: "100%", gap: "10px" }}>
              {loanOfferData
                ? loanOfferData.map((data, index) => (
                    <div
                      key={index}
                      style={{
                        padding: "10px",
                        borderRadius: "var(--br-card-radius, 12px)",
                        border: "1px solid rgba(148,163,184,0.22)",
                        position: "relative",
                        minWidth: "25%",
                        maxWidth: "30%",
                        background: "var(--br-surface, rgba(255,255,255,0.75))",
                      }}
                    >
                      <div
                        className="mui_button"
                        style={{
                          width: "28px",
                          height: "28px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "1px solid rgba(148,163,184,0.22)",
                          position: "absolute",
                          zIndex: 100,
                          top: 10,
                          right: 10,
                          borderRadius: "var(--br-card-radius, 10px)",
                          display: adjustingIndex !== null ? "none" : "flex",
                          background: "var(--br-surface, white)",
                        }}
                        onClick={() => setAdjustingIndex(index)}
                      >
                        <EditIcon style={{ color: "grey" }} />
                      </div>

                      {/* keep your existing offer edit UI exactly as you had it */}
                      <div
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: "400",
                          fontSize: "10px",
                          opacity: ".6",
                        }}
                      >
                        Offer amount
                      </div>

                      <div
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: "600",
                          fontSize: "18px",
                          color: "grey",
                        }}
                      >
                        {adjustingIndex === index ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            SGD{" "}
                            <input
                              type="number"
                              value={loanOfferData[adjustingIndex].offer_amount}
                              style={{
                                border: "1px solid rgba(148,163,184,0.28)",
                                width: "50%",
                                padding: "4px 12px",
                                borderRadius: "10px",
                              }}
                              onChange={(e) => {
                                const updatingLoanOfferData = [
                                  ...loanOfferData,
                                ];
                                updatingLoanOfferData[
                                  adjustingIndex
                                ].offer_amount = parseFloat(e.target.value);
                                setLoanOfferData(updatingLoanOfferData);
                              }}
                            />
                          </div>
                        ) : (
                          data.offer_amount.toLocaleString("en-US", {
                            style: "currency",
                            currency: "SGD",
                          })
                        )}
                      </div>

                      <div
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: "400",
                          fontSize: "10px",
                          opacity: ".6",
                          marginTop: "10px",
                        }}
                      >
                        Offer Interest Rate (Month)
                      </div>

                      <div
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: "600",
                          fontSize: "18px",
                          color: "grey",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        {adjustingIndex === index ? (
                          <input
                            type="number"
                            style={{
                              border: "1px solid rgba(148,163,184,0.28)",
                              width: "40%",
                              padding: "4px 12px",
                              borderRadius: "10px",
                            }}
                            value={
                              loanOfferData[adjustingIndex].offer_interest_rate
                            }
                            onChange={(e) => {
                              const updatingLoanOfferData = [...loanOfferData];
                              updatingLoanOfferData[
                                adjustingIndex
                              ].offer_interest_rate = parseFloat(
                                e.target.value
                              );
                              setLoanOfferData(updatingLoanOfferData);
                            }}
                          />
                        ) : (
                          data.offer_interest_rate.toFixed(1)
                        )}
                        {" %"}
                      </div>

                      <div
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: "400",
                          fontSize: "10px",
                          opacity: ".6",
                          marginTop: "10px",
                        }}
                      >
                        Processing Fee
                      </div>

                      <div
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: "600",
                          fontSize: "18px",
                          color: "grey",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        {adjustingIndex === index ? (
                          <input
                            type="number"
                            style={{
                              border: "1px solid rgba(148,163,184,0.28)",
                              width: "40%",
                              padding: "4px 12px",
                              borderRadius: "10px",
                            }}
                            value={loanOfferData[adjustingIndex].processing_fee}
                            onChange={(e) => {
                              const updatingLoanOfferData = [...loanOfferData];
                              updatingLoanOfferData[
                                adjustingIndex
                              ].processing_fee = parseFloat(e.target.value);
                              setLoanOfferData(updatingLoanOfferData);
                            }}
                          />
                        ) : (
                          data.processing_fee.toFixed(1)
                        )}
                        {" %"}
                      </div>

                      <div
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: "400",
                          fontSize: "10px",
                          opacity: ".6",
                          marginTop: "10px",
                        }}
                      >
                        Loan Tenure
                      </div>

                      <div
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: "600",
                          fontSize: "18px",
                          color: "grey",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        {adjustingIndex === index ? (
                          <input
                            type="number"
                            value={loanOfferData[adjustingIndex].offer_period}
                            style={{
                              border: "1px solid rgba(148,163,184,0.28)",
                              width: "40%",
                              padding: "4px 12px",
                              borderRadius: "10px",
                            }}
                            onChange={(e) => {
                              const updatingLoanOfferData = [...loanOfferData];
                              updatingLoanOfferData[
                                adjustingIndex
                              ].offer_period = parseFloat(e.target.value);
                              setLoanOfferData(updatingLoanOfferData);
                            }}
                          />
                        ) : (
                          data.offer_period
                        )}{" "}
                        months
                      </div>

                      {adjustingIndex === index ? (
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            marginTop: "15px",
                          }}
                        >
                          <div
                            className="mui_button"
                            style={{
                              background: "var(--br-primary, rgb(21, 87, 169))",
                              padding: "8px 18px",
                              borderRadius: "var(--br-card-radius, 10px)",
                              color: "white",
                              fontWeight: 800,
                            }}
                            onClick={() => adjustLoanOffer()}
                          >
                            Confirm changes
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ))
                : null}
            </div>
          </div>
        ) : null}
      </Modal>
    </div>
  );
};

export default Messaging;
